import esensors from "./sensorsInit";

export default new class sensors {
    officialSite_WatchVideo(eventObj) {
        esensors.track("officialSite_WatchVideo", eventObj);
    }

    officialSite_BrowseProduct(eventObj) {
        let source = "";
        switch (eventObj.source) {
            case "wechat":
                source = "公众号链接";
                break;
            case "qrcode":
                source = "扫描二维码";
                break;
            case "copyurl":
                source = "侧边栏-复制链接";
                break;
            case "more":
                source = "产品页-更多产品";
                break;
            case "footer":
                source = "产品页-底部栏";
                break;
            case "header":
                source = "产品页-顶部栏";
                break;
            case "siteProductCenter":
                source = "官网顶部栏-产品中心";
                break;
            case "siteProductSuggest":
                source = "官网首页产品介绍";
                break;
            default:
                source = "无前向入口";
                break;
        }
        let obj = {
            officialSite_e_source: source,
            officialSite_e_title: eventObj.title
        };
        esensors.track("officialSite_BrowseProduct", obj);
    }

    officialSite_SubmitFreeUse() {
        esensors.track("officialSite_SubmitFreeUse");
    }

    officialSite_FreeUseDetails(eventObj) {
        let source = "";
        switch (eventObj.officialSite_e_freeUseDetailsSource) {
            case "indexModule":
                source = "产品页-联系我们";
                break;
            case "sidebar":
                source = "侧边栏-联系我们";
                break;
            case "footer":
                source = "底部栏-联系我们";
                break;
            case "nav":
                source = "顶部导航栏-免费试用";
                break;
            case "banner":
                source = "首页Banner背景图-免费试用";
                break;
            case "advert":
                source = "广告位-免费试用";
                break;
            case "price":
                source = "产品定价";
                break;
            case "qrcode":
                source = "扫描二维码";
                break;
            case "copyurl":
                source = "侧边栏-复制链接";
                break;
            default:
                source = "无前向入口";
                break;
        }
        let obj = {
            officialSite_e_freeUseDetailsSource: source,
            officialSite_e_productName: eventObj.officialSite_e_productName,
            officialSite_e_intentionType: eventObj.officialSite_e_intentionType,
            officialSite_e_isSuccess: eventObj.officialSite_e_isSuccess
        };
        esensors.track("officialSite_FreeUseDetails", obj);
    }

    officialSite_Share(eventObj) {
        esensors.track("officialSite_Share", eventObj);
    }

    // 联系我们
    officialSite_Contact() {
        esensors.track('officialSite_Contact')
    }

    officialSite_Consult(eventObj) {
        esensors.track("officialSite_Consult", eventObj);
    }

    // 路由菜单事件
    officialSite_Router(eventObj) {
        esensors.track('officialSite_Router', eventObj)
    }

    // 合作故事页
    officialSite_Story(eventObj) {
        esensors.track('officialSite_Story', eventObj)
    }

    // 合作故事详情页事件
    officialSite_StoryDetail(eventObj) {
        esensors.track('officialSite_StoryDetail', eventObj)
    }
};
